import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

import './style.css';

export const Revolution = ({ joinHandler }) => {
  const { ref: revRef, inView: isVisible } = useInView();

  return (
    <div className='wrapper-revolution'>
      <div className='star-div'></div>
      <div className='half-moon'></div>

      <div className='revolution-div'>
        <span className='revolution-heading'>
          Join the{' '}
          <span className='revolution-heading-color'>Kalam Revolution</span>{' '}
        </span>
        <div className='revolution-stats-div'>
          <div className='revolution-pic'></div>
          <div ref={revRef} className='revolution-stats'>
            <div className='stat'>
              <span className='revolution-number'>
                <CountUp
                  start={0}
                  end={30000}
                  duration={2}
                  useEasing={true}
                  redraw={isVisible}
                />
                +
              </span>
              <span className='revolution-label'>Students</span>
            </div>
            <div className='stat'>
              <span className='revolution-number'>
                <CountUp
                  start={0}
                  end={500}
                  duration={2}
                  useEasing={true}
                  redraw={isVisible}
                />
                +
              </span>
              <span className='revolution-label'>Schools</span>
            </div>{' '}
            <div className='stat'>
              <span className='revolution-number'>
                <CountUp
                  start={0}
                  end={10}
                  duration={2}
                  useEasing={true}
                  redraw={isVisible}
                />
                +
              </span>
              <span className='revolution-label'>Countries</span>
            </div>
          </div>
        </div>
        <div className='btn-div'>
          <div className='google-btn'></div>
          <div className='apple-btn'></div>
          <div className='windows-btn'></div>
        </div>
        <div className='footer-div'>
          <span className='footer-heading'>
            Let your Child Explore the Universe with Kalam Labs
          </span>
          <span className='footer-btn' onClick={joinHandler}>
            Join now
          </span>
        </div>
      </div>
      <div className='sponsors-div'>
        <span className='sponsors-heading'>
          Kalam Labs Has Been Featured in
        </span>
        <div className='sponsors-wrapper'></div>
      </div>
      <div className='mobile-footer'>
        <span className='mobile-footer-text'>
          Let your Child Explore the <br />
          Universe with Kalam Labs
        </span>
        <span className='mobile-footer-btn' onClick={joinHandler}>
          {' '}
          Join now{' '}
        </span>
      </div>
    </div>
  );
};
